var _defs, _g, _path, _g2, _path2, _g3, _path3, _g4, _path4, _g5, _path5, _g6, _path6, _path7, _g7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _g8, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScPaderborn07Logo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 89.321,
    height: 61.74,
    viewBox: "0 0 66.991 46.305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155 293.39h58v53.289h-58z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157 293.39h56v33.613h-56z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155 315h64.969v17H155z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158 321h53v25.676h-53z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.82 307H163v20h-14.18z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    x: 69.911,
    y: 459.485,
    transform: "translate(-150.24 -296.64)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    x: 73.321,
    y: 459.485,
    transform: "translate(-150.24 -296.64)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    x: 51.473,
    y: 466.436,
    transform: "translate(-150.24 -296.64)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.78 22.96C11.776 10.605 21.792.585 34.163.577 46.507.585 56.526 10.604 56.518 22.96c.008 12.359-10.012 22.379-22.355 22.383C21.792 45.339 11.776 35.32 11.78 22.96"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "translate(-150.24 -296.64)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 3.864,
    strokeWidth: 1.135,
    d: "M162.02 319.6c-.004-12.354 10.012-22.374 22.383-22.382 12.344.007 22.363 10.027 22.355 22.383.007 12.359-10.012 22.379-22.355 22.383-12.371-.004-22.387-10.023-22.383-22.383z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.5 15.5h-1.375C16.465 6.023 24.715.586 34.16.574c12.613.012 22.949 10.793 22.355 23.418h-1.348C55.73 12.117 46.02 1.945 34.16 1.953 25.38 1.945 17.792 6.797 14.5 15.5"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(-150.24 -296.64)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 3.864,
    strokeWidth: 1.135,
    d: "M164.738 312.142h-1.375c3.34-9.477 11.59-14.914 21.035-14.926 12.613.011 22.95 10.793 22.355 23.418h-1.347c.562-11.875-9.149-22.047-21.008-22.04-8.782-.007-16.367 4.845-19.66 13.548z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.44 28.38c-.16-.652-.25-1.027-.371-1.691-.11-.66-.156-1.036-.23-1.696h54.495l-.515 3.387z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    transform: "translate(-150.24 -296.64)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 3.864,
    strokeWidth: 1.135,
    d: "M162.68 325.019c-.16-.653-.25-1.028-.371-1.692-.11-.66-.157-1.035-.23-1.695h54.495l-.515 3.387z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.78 29.41h42.73c-2.96 9.95-12.207 15.922-21.352 15.926-9.379-.004-18.414-5.977-21.379-15.926"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "translate(-150.24 -296.64)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 3.864,
    strokeWidth: 0.908,
    d: "M163.02 326.05h42.73c-2.961 9.95-12.207 15.923-21.352 15.927-9.38-.004-18.414-5.977-21.38-15.926z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.23 19.06c-.074.559-.453.863-.973.832l.258-1.691.14-.032c.473.008.66.43.575.891m-1.606 4.934.372-2.438c1.671.051 2.906-.535 3.187-2.469.313-1.93-.906-2.5-2.613-2.496H1.82L.67 23.994z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "translate(-150.24 -296.64)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 3.864,
    strokeWidth: 1.135,
    d: "m152.86 320.632.374-2.442c1.672.051 2.903-.535 3.184-2.468.312-1.93-.902-2.5-2.61-2.496h-1.753l-1.149 7.406zm1.609-4.938c-.074.559-.457.864-.977.832l.258-1.691.145-.031c.472.008.656.43.574.89z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m8.19 21.47.516-1.723c.152-.46.273-.933.402-1.406h.031c-.039.473-.074.945-.09 1.406l-.054 1.723zm2.812 2.527-.402-7.406H8.25l-2.872 7.406h2.008l.29-.976h1.32v.976z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 3.864,
    strokeWidth: 1.135,
    d: "m11 23.99-.398-7.406H8.246L5.38 23.99h2.008l.285-.977h1.32v.977zm-2.812-2.527.519-1.723c.148-.46.27-.934.402-1.406h.028c-.036.472-.07.945-.086 1.406l-.059 1.723z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 3.864,
    strokeWidth: 1.135,
    d: "M14.42 18.42c.887.004.867 1.121.746 1.922-.11.7-.437 1.84-1.32 1.84zM17.52 23.99h3.586l.289-1.75h-1.668l.172-1.152h1.496l.258-1.72H20.16l.171-1.034h1.665l.257-1.75h-3.617z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.81 20 .285-1.836c.535-.023.871.25.778.89-.079.489-.426.95-.95.946zm2.555 3.988-.977-3.097c.824-.309 1.281-1.032 1.406-1.836.297-1.961-.843-2.473-2.527-2.47h-1.863l-1.149 7.403h1.953l.285-1.98c.067-.367.102-.727.145-1.09l.027-.027.602 3.097z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 3.864,
    strokeWidth: 1.135,
    d: "m27.36 23.99-.977-3.102c.825-.308 1.278-1.03 1.407-1.835.297-1.961-.844-2.473-2.528-2.47H23.4l-1.148 7.407H24.2l.289-1.98c.066-.368.101-.731.14-1.094l.032-.028.601 3.102zm-2.555-3.992.285-1.836c.532-.023.872.254.778.89-.078.489-.426.95-.95.946z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m30.63 19.46.2-1.262h.198c.387-.015.657.172.575.602-.063.492-.457.66-.86.66zm-.46 2.926.23-1.434h.144c.457.008.797.215.719.715s-.492.715-.922.719zm-2.18 1.61h2.609c1.734-.016 2.453-1.212 2.586-2.126.16-.988-.254-1.597-1.18-1.664v-.031c.809 0 1.43-.649 1.55-1.492.255-1.586-1-2.098-2.152-2.094h-2.265z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 3.864,
    strokeWidth: 1.135,
    d: "M27.99 23.99h2.61c1.734-.016 2.452-1.21 2.585-2.125.16-.988-.25-1.598-1.18-1.664v-.031c.81 0 1.43-.649 1.551-1.492.254-1.586-1-2.098-2.152-2.094h-2.266zm2.18-1.61.23-1.433h.145c.457.008.797.215.718.715-.078.5-.492.715-.921.719zm.46-2.925.2-1.262h.203c.383-.015.652.172.57.602-.062.492-.457.66-.86.66z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M36.11 20.29c.086-.469.344-1.973 1.09-1.98.719.008.515 1.511.457 1.98-.082.453-.344 1.953-1.059 1.95-.75.003-.547-1.497-.488-1.95m-1.953 0c-.29 1.797.168 3.813 2.152 3.813 1.957 0 3.04-2.016 3.3-3.813.29-1.816-.167-3.836-2.151-3.848-1.957.012-3.036 2.032-3.301 3.848"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 3.864,
    strokeWidth: 1.135,
    d: "M34.16 20.29c-.29 1.797.172 3.813 2.152 3.813 1.957 0 3.04-2.016 3.301-3.813.293-1.816-.168-3.836-2.152-3.848-1.957.012-3.035 2.032-3.301 3.848zm1.953 0c.086-.469.344-1.973 1.09-1.98.719.008.516 1.511.46 1.98-.085.453-.343 1.953-1.062 1.95-.746.003-.543-1.497-.488-1.95z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m42.54 20 .285-1.836c.531-.023.871.25.777.89-.078.489-.425.95-.949.946zm2.555 3.988-.977-3.097c.824-.309 1.278-1.032 1.406-1.836.297-1.961-.843-2.473-2.527-2.47h-1.863l-1.149 7.403h1.953l.286-1.98c.062-.367.101-.727.144-1.09l.027-.027.602 3.097z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 3.864,
    strokeWidth: 1.135,
    d: "m45.1 23.99-.977-3.102c.825-.308 1.282-1.03 1.407-1.835.297-1.961-.84-2.473-2.524-2.47H41.14l-1.144 7.407h1.949l.285-1.98c.066-.368.101-.731.144-1.094l.028-.028.605 3.102zm-2.555-3.992.29-1.836c.53-.023.867.254.773.89-.078.489-.426.95-.95.946z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeMiterlimit: 3.864,
    strokeWidth: 1.135,
    d: "M45.73 23.99h1.867l.344-2.184c.102-.695.121-1.382.172-2.066l.031-.027.8 4.277h1.868l1.117-7.406h-1.867l-.285 1.894c-.13.84-.117 1.68-.172 2.528l-.031.027-.86-4.45h-1.836z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#1963b8",
    d: "M12.78 29.41h42.73c-2.96 9.95-12.207 15.922-21.352 15.926-9.379-.004-18.414-5.977-21.379-15.926"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M12.44 28.38c-.16-.652-.25-1.027-.371-1.691-.11-.66-.156-1.036-.23-1.696h54.495l-.515 3.387z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#141411",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.23 19.06c-.074.559-.453.863-.973.832l.258-1.691.14-.032c.473.008.66.43.575.891m-1.606 4.934.372-2.438c1.671.051 2.906-.535 3.187-2.469.313-1.93-.906-2.5-2.613-2.496H1.82L.67 23.994zM8.19 21.47l.516-1.723c.152-.46.273-.933.402-1.406h.031c-.039.473-.074.945-.09 1.406l-.054 1.723zm2.812 2.527-.402-7.406H8.25l-2.872 7.406h2.008l.29-.976h1.32v.976zM14.42 18.42c.887.004.867 1.121.746 1.922-.11.7-.437 1.84-1.32 1.84zm-2.672 5.566h1.695c1.176-.011 3.309-.324 3.817-3.73.36-2.246-.61-3.676-2.813-3.672H12.87zM17.52 23.99h3.586l.289-1.75h-1.668l.172-1.152h1.496l.258-1.72H20.16l.171-1.034h1.665l.257-1.75h-3.617zM24.81 20l.285-1.836c.535-.023.871.25.778.89-.079.489-.426.95-.95.946zm2.555 3.988-.977-3.097c.824-.309 1.281-1.032 1.406-1.836.297-1.961-.843-2.473-2.527-2.47h-1.863l-1.149 7.403h1.953l.285-1.98c.067-.367.102-.727.145-1.09l.027-.027.602 3.097zM30.63 19.46l.2-1.262h.198c.387-.015.657.172.575.602-.063.492-.457.66-.86.66zm-.46 2.926.23-1.434h.144c.457.008.797.215.719.715s-.492.715-.922.719zm-2.18 1.61h2.609c1.734-.016 2.453-1.212 2.586-2.126.16-.988-.254-1.597-1.18-1.664v-.031c.809 0 1.43-.649 1.55-1.492.255-1.586-1-2.098-2.152-2.094h-2.265zM36.11 20.29c.086-.469.344-1.973 1.09-1.98.719.008.515 1.511.457 1.98-.082.453-.344 1.953-1.059 1.95-.75.003-.547-1.497-.488-1.95m-1.953 0c-.29 1.797.168 3.813 2.152 3.813 1.957 0 3.04-2.016 3.3-3.813.29-1.816-.167-3.836-2.151-3.848-1.957.012-3.036 2.032-3.301 3.848M42.54 20l.285-1.836c.531-.023.871.25.777.89-.078.489-.425.95-.949.946zm2.555 3.988-.977-3.097c.824-.309 1.278-1.032 1.406-1.836.297-1.961-.843-2.473-2.527-2.47h-1.863l-1.149 7.403h1.953l.286-1.98c.062-.367.101-.727.144-1.09l.027-.027.602 3.097zM45.73 23.99h1.867l.344-2.184c.102-.695.121-1.382.172-2.066l.031-.027.8 4.277h1.868l1.117-7.406h-1.867l-.285 1.894c-.13.84-.117 1.68-.172 2.528l-.031.027-.86-4.45h-1.836zM38.5 4.59a2.9 2.9 0 0 0-1.086-.172c-1.062-.012-3.512.61-3.504 4.278-.008 2.82 1.492 4.199 3.242 4.187.489.012.88-.086 1.325-.285l.113-2.297c-.348.332-.652.527-1.149.516-1.066.011-1.343-1.207-1.351-2.153.008-.914.285-2.187 1.406-2.18.441-.007.695.165 1.004.462zm-9.21 7.977c.5.21 1.058.328 1.608.316 1.497.012 2.532-1.207 2.524-2.727.008-.62-.129-1.058-.375-1.433-.25-.363-.61-.668-1.059-1.004-.12-.09-.28-.2-.402-.316-.11-.145-.203-.297-.2-.458-.003-.328.302-.515.544-.519.508.004 1.023.473 1.261.89V4.82a3.05 3.05 0 0 0-1.52-.402c-1.831-.012-2.421 1.73-2.41 2.7-.011.59.157 1.046.43 1.433.266.383.633.7 1.063 1.031.129.106.258.203.344.317a.6.6 0 0 1 .172.46c.008.36-.333.547-.63.547-.546 0-1.062-.457-1.351-.918z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M30.57 38.48c-.664-.008-.707-1.434-.715-2.355.008-.93.051-2.356.715-2.352.645-.004.684 1.422.691 2.352-.008.921-.046 2.347-.691 2.355m0-6.602c-2.227-.004-2.828 2.422-2.84 4.247.012 1.09.23 2.41.89 3.273.434.582 1.06.965 1.95.973.867-.008 1.496-.391 1.926-.973.664-.863.883-2.184.887-3.273-.004-1.825-.606-4.25-2.813-4.247m3.36.141v1.895h2.699l-2.586 5.484-.371.828h2.324l.344-.828 3.242-7.379z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#1961b5",
    d: "M14.5 15.5h-1.375C16.465 6.023 24.715.586 34.16.574c12.613.012 22.949 10.793 22.355 23.418h-1.348C55.73 12.117 46.02 1.945 34.16 1.953 25.38 1.945 17.792 6.797 14.5 15.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScPaderborn07Logo);
export default __webpack_public_path__ + "static/media/SC_Paderborn_07_Logo.c5aaa3e8922abda4a042cd6a64edccbf.svg";
export { ForwardRef as ReactComponent };